module.exports = __webpack_public_path__ + "img/yinglifenxi.a794a65f.png";